export const portalRouter = [
    {
        path: '/',
        component: () => import('../../views/portal/Home.vue'),
        name: 'homePage',
        meta: { title: '蒙山茶马司', pCode: 'portal' }
    },
    {
        path: '/detail',
        component: () => import('../../views/portal/Detail.vue'),
        name: 'Details',
        meta: { pCode: 'portal' }
    },
    {
        path: '/dav',
        component: () => import('../../views/portal/Dav.vue'),
        name: 'Dav',
        meta: { pCode: 'portal' }
    },
    {
        path: '/new-tea',
        component: () => import('../../views/new-tea/Index.vue'),
        name: 'NewTea',
        meta: { pCode: 'new-tea' }
    },
    {
        path: '/leading',
        component: () => import('../../views/leading/Index.vue'),
        name: 'Leading',
        meta: { pCode: 'leading' }
    },
    {
        path: '/source',
        component: () => import('../../views/source/Index.vue'),
        name: 'Source',
        meta: { pCode: 'source' }
    },
    {
        path: '/great',
        component: () => import('../../views/great/Index.vue'),
        name: 'Great',
        meta: { pCode: 'great' }
    },
    {
        path: '/joinUs',
        component: () => import('../../views/joinUs/Index.vue'),
        name: 'JoinUs',
        meta: { pCode: 'joinUs' }
    },
    {
        path: '/greenEcology',
        component: () => import('../../views/greenEcology/Index.vue'),
        name: 'GreenEcology',
        meta: { pCode: 'greenEcology' }
    },
    {
        path: '/humanisticCare',
        component: () => import('../../views/humanisticCare/Index.vue'),
        name: 'HumanisticCare',
        meta: { pCode: 'humanisticCare' }
    },
    {
        path: '/culturalProtection',
        component: () => import('../../views/culturalProtection/Index.vue'),
        name: 'CulturalProtection',
        meta: { pCode: 'culturalProtection' }
    },
    {
        path: '/craftsmanship',
        component: () => import('../../views/craftsmanship/Index.vue'),
        name: 'Craftsmanship',
        meta: { pCode: 'craftsmanship' }
    },
    {
        path: '/missionValues',
        component: () => import('../../views/missionValues/Index.vue'),
        name: 'MissionValues',
        meta: { pCode: 'missionValues' }
    },
    {
        path: '/corporateBrochure',
        component: () => import('../../views/corporateBrochure/Index.vue'),
        name: 'CorporateBrochure',
        meta: { pCode: 'corporateBrochure' }
    }
]